import { Phone, Mail } from "lucide-react";
import { CONTACT } from "../../data";
import { Reveal } from "./Reveal";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative py-28 md:py-40 overflow-hidden">
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[60vh] w-[60vh] rounded-full bg-[#bf953f]/10 blur-[150px]" />
    <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
      <Reveal>
        <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">Get In Touch</p>
        <h2 className="mt-5 font-serif-display text-5xl sm:text-6xl md:text-7xl font-medium tracking-tight text-white">
          Secure your <span className="text-gold-gradient italic">legacy.</span>
        </h2>
        <p className="mt-6 mx-auto max-w-xl font-body font-light text-base md:text-lg leading-relaxed text-white/60">
          No forms, no waiting rooms. Call or email a Heritage advisor directly and start protecting what
          matters today.
        </p>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-5">
          <a
            href={CONTACT.phoneHref}
            data-testid="contact-phone-link"
            className="btn-sweep group inline-flex items-center gap-3 rounded-full bg-gold-metallic px-8 py-4 font-body font-medium text-black"
          >
            <Phone size={18} />
            {CONTACT.phone}
          </a>
          <a
            href={CONTACT.emailHref}
            data-testid="contact-email-link"
            className="inline-flex items-center gap-3 rounded-full border border-[#bf953f]/40 px-8 py-4 font-body tracking-wide text-white/85 hover:text-[#fcf6ba] hover:border-[#d4af37] transition-colors duration-300"
          >
            <Mail size={18} className="text-[#d4af37]" />
            {CONTACT.email}
          </a>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <p className="mt-10 font-body text-sm text-white/40">
          Advisors available Mon–Sat · Licensed & independent
        </p>
      </Reveal>
    </div>
  </section>
);
